import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* searchCoverages(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/coverage/?search=' + actions.value, requestOptions)

        yield put({ type: "COVERAGES_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "COVERAGES_RESPONSE", value: error })
    }
}

function* zonesProduct(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/zone/?offset=0&limit=' + actions.limit, requestOptions)

        yield put({ type: "ZONES_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "ZONES_RESPONSE", value: error })
    }
}

export function* suppliersProduct(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/supplier/?offset=0&limit=' + actions.limit, requestOptions)

        yield put({ type: "SUPPLIER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "SUPPLIER_RESPONSE", value: error })
    }
}

export function* allManagers(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        const response = yield call(apiCall, 'get', config.credentials.url + '/profile_name_id/' + actions.query, requestOptions);
        yield put({ type: "GET_MANGERS_LIST_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "GET_MANGERS_LIST_RESPONSE", value: error })
    }
}

export function* categoriesProduct(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/product_type/?offset=0&limit=' + actions.limit, requestOptions)

        yield put({ type: "CATEGORY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CATEGORY_RESPONSE", value: error })
    }
}

function* officesProduct(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/office/?offset=0&limit=' + actions.limit, requestOptions)

        yield put({ type: "OFFICES_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "OFFICES_RESPONSE", value: error })
    }
}

function* infoStep(actions) {
    yield put({ type: "INFO_STEP", infoStep: actions.infoStep, step: actions.step })
}

function* infoStepRefund(actions) {

    yield put({ type: "INFO_STEP_REFUND", infoStep: actions.infoStep, step: actions.step, createRefund: actions.createRefund })

}

function dataStep(numberStep, info) {
    let response = {}

    if (numberStep === 0) {
        response["short_name"] = info["category"]["short_name"];
        response["url_image"] = info["category"]["url_image"];
        response["long_name"] = info["category"]["long_name"];
        response["is_enabled"] = info["category"]["is_enabled"];
        response["product_code"] = info["category"]["product_code"];
        response["supplier_reference"] = info["category"]["supplier_reference"] || null;
        response["product_type"] = info["category"]["product_type_id"];
        response["supplier"] = info["category"]["supplier_id"];
        response["zone"] = info["zones"]["zone_id"];
        response["office"] = info["offices"]["offices"];
    }

    if (numberStep === 1) {
        response["product_coverage"] = info["product_coverage"]
    }

    return response;
}

function* createProduct(dataProduct, access) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(dataProduct)
        };
        const productResponse = yield call(apiCall, 'post', config.credentials.url + '/productCreate/', requestOptions)
        console.log('%c ////// 1 ////// createProduct / dataProduct :', 'color: #ffffff; background: #00b3aa', dataProduct);
        console.log('%c ////// 2 ////// createProduct / productResponse :', 'color: #ffffff; background: #00b3aa', productResponse);
        yield put({ type: "PRODUCT_RESPONSE_FINAL", response: dataProduct, productResponse: productResponse })
    } catch (error) {
        yield put({ type: "PRODUCT_RESPONSE_FINAL", response: error })
    }
}
function* stepProduct(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        let bodyRequest = '';
        if (actions.currentNumberStep === 1) {
            const current = dataStep(actions.currentNumberStep, actions.currentStep);
            if (actions.view === 'clone')
                current["id"] = actions.id;

            const last = dataStep(actions.lastStep[0]["step"], actions.lastStep[0]["info"])
            bodyRequest = Object.assign(current, last)
        }
        if (actions.currentNumberStep === 2) {
            bodyRequest = actions.currentStep
        }

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(bodyRequest)
        };

        const dataProduct = yield call(apiCall, 'post', config.credentials.url + '/step/', requestOptions)

        if (dataProduct.hash !== undefined && actions.currentNumberStep === 2) {
            yield createProduct(dataProduct, actions.access);
        } else {
            yield put({ type: "PRODUCT_RESPONSE", response: dataProduct })
        }
    } catch (error) {
        yield put({ type: "PRODUCT_RESPONSE", response: error })
    }
}

function* editProduct(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        let stepsUno = actions.lastStep.filter(e => e.step === 0)
        let stepUno = stepsUno[stepsUno.length - 1]
        let stepsDos = actions.lastStep.filter(e => e.step === 1)
        let stepDos = stepsDos[stepsDos.length - 1]

        const bodyRequest = {
            "id": actions.id,
            "short_name": stepUno["info"]["category"]["short_name"],
            "long_name": stepUno["info"]["category"]["long_name"],
            "product_code": stepUno["info"]["category"]["product_code"],
            "supplier_reference": stepUno["info"]["category"]["supplier_reference"] || null,
            "is_enabled": stepUno["info"]["category"]["is_enabled"],
            "url_image": stepUno["info"]["category"]["url_image"],
            "product_type": stepUno["info"]["category"]["product_type_id"],
            "supplier": stepUno["info"]["category"]["supplier_id"],
            "zone": stepUno["info"]["zones"]["zone_id"],
            "office": stepUno["info"]["offices"]["offices"],
            "product_coverage": stepDos["info"]["product_coverage"],
            "rate": actions.currentStep["rate"]
        }
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(bodyRequest)
        };

        const dataProduct = yield call(apiCall, 'post', config.credentials.url + '/productEdit/', requestOptions)
        yield put({ type: "PRODUCT_RESPONSE_EDIT", response: dataProduct })
    } catch (error) {
        yield put({ type: "PRODUCT_RESPONSE_EDIT", response: error })
    }
}

function product(actions) {
    if (actions.view === "create") {
        return stepProduct(actions)
    }

    if (actions.view === "edit") {
        return editProduct(actions);
    }

    if (actions.view === 'clone') {
        return stepProduct(actions)
    }
}

function* file(actions) {
    try {
        const headers = {
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: actions.file
        };

        const response = yield call(apiCall, 'post', config.credentials.url + '/csv_upload/', requestOptions)

        yield put({ type: "FILE_RESPONSE", value: response, tipoTarifa: actions.tipoTarifa })

    } catch (error) {
        yield put({ type: "FILE_RESPONSE", value: error, tipoTarifa: actions.tipoTarifa })
    }
}

function* coveragesProduct(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/coverage/' : config.credentials.url + '/coverage/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "COVERAGES_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "COVERAGES_RESPONSE", value: error })
    }
}


function* rateDetail(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/rateDetail/' + actions.id + '/', requestOptions)

        yield put({ type: "RATE_DETAIL_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "RATE_DETAIL_RESPONSE", value: error })
    }
}

function* updateOfficesRate(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/updateOfficeRate/', requestOptions)

        yield put({ type: "EDIT_OFFICES_RATE_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "EDIT_OFFICES_RATE_RESPONSE", value: error })
    }
}
function* image(actions) {

    try {

        const headers = {
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: actions.file
        };

        const response = yield call(apiCall, 'post', config.credentials.url + '/upload_image/', requestOptions)

        yield put({ type: "IMAGE_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "IMAGE_RESPONSE", value: error })
    }
}

function* postReintegro(actions) {
    try {

        const headers = {
            'Content-Type': "multipart/form-data",
        };

        const requestOptions = {

            body: actions.formData
        };

        const response = yield call(apiCall, 'post', config.credentials.url + '/refund_data/', requestOptions)

        yield put({ type: "REINTEGRO_CREATE_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "REINTEGRO_CREATE_RESPONSE", value: error })
    }
}

function* getListReintegros(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/refund/?offset=0&limit=' + actions.limit : config.credentials.url + '/refund/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)
        response.view = 'list'

        yield put({ type: "REINTEGROS_LIST_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "REINTEGROS_LIST_RESPONSE", value: error })
    }
}

function* hashExportRefunds(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? config.credentials.url + '/refund_report/?offset=0&limit=1000000'
                : config.credentials.url + '/refund_report/' + actions.query + '&offset=0&limit=100000';

        const response = yield call(apiCall, 'get', url, requestOptions);
        //saveAs(response.message, "filter_Offices.xlsx")
        yield put({ type: 'HASH_EXPORT_REFUNDS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'HASH_EXPORT_REFUND_RESPONSE', value: error });
    }
}

function* checkExportRefunds(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_REFUNDS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_REFUNDS_RESPONSE', value: error });
    }
}

function* reintegro(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/refund/' : config.credentials.url + '/refund/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)
        response.view = 'show'

        yield put({ type: "REINTEGRO_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "REINTEGRO_RESPONSE", value: error })
    }
}

function* refundData(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = config.credentials.url + '/refund_data/?voucher_id=' + actions.query.voucher + '&document=' + actions.query.doc_number + '&refund_id=' + actions.query.id

        const data = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "REFUND_DATA_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "REFUND_DATA_RESPONSE", value: error })
    }
}

function* refundDataImages(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };

        let jsonRequest = {
            'refund_files_ids': actions.query,
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(jsonRequest),
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/refund_download_file/',
            requestOptions);

        yield put({ type: 'PRINT_REFUND_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'PRINT_REFUND_RESPONSE', value: error });
    }
}

function* editRefund(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'PATCH', config.credentials.url + '/refund_data/', requestOptions)

        response.view = 'edit'

        yield put({ type: "REINTEGRO_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "REINTEGRO_RESPONSE", value: error })
    }
}

function* uploadImageRefund(actions) {
    try {
        const headers = {
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: actions.data,
        };

        const url = config.credentials.url + '/refund_upload_file/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "UPLOAD_IMAGE_REFUND_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "UPLOAD_IMAGE_REFUND_RESPONSE", value: error })
    }
}

function* getComment(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        let url = config.credentials.url + '/refund_comments/' + actions.query
        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "REFUND_COMMENTS_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "REFUND_COMMENTS_RESPONSE", value: error })
    }
}


function* createComment(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/refund_comments/', requestOptions);

        yield put({ type: "CREATE_COMMENTS_REFUND_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "CREATE_COMMENTS_REFUND_RESPONSE", value: error })
    }
}


export function* getSuppliers() {
    yield takeLatest("GET_SUPPLIERS_PRODUCT", suppliersProduct)
}

export function* getAllManagers() {
    yield takeLatest("GET_ALL_MANAGERS", allManagers)
}

export function* getCategories() {

    yield takeLatest("GET_CATEGORIES_PRODUCT", categoriesProduct)
}
export function* getCoverages() {
    yield takeEvery("GET_COVERAGES_PRODUCT", coveragesProduct)
}

export function* getZones() {
    yield takeEvery("GET_ZONES_PRODUCT", zonesProduct)
}

export function* getOffices() {
    yield takeEvery("GET_OFFICES_PRODUCT", officesProduct)
}

export function* saveInfoStep() {
    yield takeEvery("SAVE_INFO_STEP", infoStep)
}

export function* saveInfoStepRefund() {
    yield takeEvery("SAVE_INFO_STEP_REFUND", infoStepRefund)
}

export function* updateProduct() {
    yield takeEvery("UPDATE_PRODUCT", product)
}

export function* getSearchCoverages() {
    yield takeEvery("GET_SEARCH_COVERAGES", searchCoverages)
}

export function* uploadFile() {

    yield takeEvery("UPLOAD_FILE", file)
}

export function* getRateDetail() {

    yield takeEvery("GET_RATE_DETAIL", rateDetail)
}

export function* editOfficesRate() {

    yield takeEvery("EDIT_OFFICES_RATE", updateOfficesRate)
}

export function* uploadImage() {

    yield takeEvery("UPLOAD_IMAGE", image)
}

export function* saveReintegro() {

    yield takeEvery("SAVE_REINTEGRO", postReintegro)
}

export function* getReintegros() {

    yield takeEvery("GET_REINTEGROS", getListReintegros)
}

export function* getHashExportReintegrosList() {
    yield takeEvery('GET_HASH_EXPORT_REFUNDS', hashExportRefunds);
}

export function* checkExportReintegrosList() {
    yield takeEvery('CHECK_EXPORT_REFUNDS', checkExportRefunds);
}

export function* getReintegro() {

    yield takeEvery("GET_REINTEGRO", reintegro)
}

export function* getRefundData() {

    yield takeEvery("GET_REFUND_DATA", refundData)
}

export function* getRefundDataImages() {

    yield takeEvery("GET_REFUND_IMAGES", refundDataImages)
}

export function* editReintegro() {
    yield takeEvery("EDIT_REINTEGRO", editRefund)
}

export function* uploadImageReintegro() {
    yield takeEvery("UPLOAD_IMAGE_REFUND", uploadImageRefund)
}

export function* getCommentRefund() {
    yield takeEvery("GET_COMMENT_REFUND", getComment)
}

export function* createCommentRefund() {
    yield takeEvery("CREATE_COMMENT_REFUND", createComment)
}